import React, { useEffect } from 'react';
import { site } from '@panel/commons/helpers';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Title } from '../../../styles';
import BillingEditable from './editable';
import BillingReadOnly from './readOnly';
import { selectBillingInfo, setTaxConditions } from '../../../../../../ducks/step4Module2';
import { getTaxConditions } from '../../../../../../utils/identificationTypes';

const siteId = site.id;

function BillingSection() {
  const { idClienteSap } = useSelector(selectBillingInfo);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isBillingReadOnly = !!idClienteSap;

  useEffect(() => {
    dispatch(setTaxConditions(getTaxConditions(siteId)));
  }, [dispatch]);

  return (
    <>
      <Title secondary>{t('publisher.step4.module2.billing.title')}</Title>
      {isBillingReadOnly ? <BillingReadOnly /> : <BillingEditable />}
    </>
  );
}

export default BillingSection;
